import React from 'react';
import "./List.css";
import { NavLink } from 'react-router-dom';
import logoImg from '../logo.svg';
import {Icon} from 'react-icons-kit';
import {menu} from 'react-icons-kit/feather/menu';
import {arrowUp} from 'react-icons-kit/feather/arrowUp';
import {trash} from 'react-icons-kit/feather/trash';
import {eye} from 'react-icons-kit/feather/eye';
import {arrowUpRight} from 'react-icons-kit/feather/arrowUpRight'

function List() {
    return (
        <div className="dashboard-content">
            <div className="mobileOption d-flex align-items-center justify-content-between">
                <div  className="buyMore"><img className="img-fluid" src={logoImg} alt=""/></div>
                <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
            </div>
            <div className="body-cart tab-content dasContent p-4 bg-white rounded">
                <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
                    <h1 className="heading h4 mb-0 fw-bold">Seller Management <br/><small className="text-primary h6 fw-bold">Total counts 5</small></h1>
                    <div className="d-inline-flex gap-2">
                        <NavLink to="#" className="btn btn-primary addSeller">Add Seller</NavLink>
                        <button className="btn btn-outline-primary filter" type="button" data-bs-toggle="collapse" data-bs-target="#filter" aria-expanded="false" aria-controls="filter">Filter List</button>
                    </div>
                    
                </div>
                <div className="collapse mb-4" id="filter">
                    <div className="card card-body">
                        <form className="filterForm" action="/">
                            <div className="row">
                                <div className="col-lg-12 mb-2">
                                    <h4 className="text-primary h6 fw-bold">Filter Things</h4>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-4 mb-2">
                                    <div className="form-floating">
                                        <select className="form-select" id="floatBilling" aria-label="Billing">
                                            <option defaultValue>Select</option>
                                            <option value="1">One</option>
                                            <option value="2">Two</option>
                                            <option value="3">Three</option>
                                        </select>
                                        <label htmlFor="floatBilling">Billing</label>
                                    </div>
                                </div>
                                <div className="col-lg-4 mb-2">
                                    <div className="form-floating">
                                        <select className="form-select" id="floatStatus" aria-label="Status">
                                            <option defaultValue>Select</option>
                                            <option value="1">One</option>
                                            <option value="2">Two</option>
                                            <option value="3">Three</option>
                                        </select>
                                        <label htmlFor="floatStatus">Status</label>
                                    </div>
                                </div>
                                <div className="col-lg-4 mb-2">
                                    <button type="submit" className="btn btn-primary btn-lg save-btn text-uppercase w-100">Submit</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="searchList row">
                    <div className="displayRecord d-flex align-items-center col-lg-6 mb-2">
                        <span className="h6 mb-0">Display Records</span>
                        <select className="form-select">
                            <option defaultValue>5</option>
                            <option value="10">10</option>
                            <option value="15">15</option>
                            <option value="20">20</option>
                        </select>
                    </div>
                    <div className="searchForm d-flex justify-content-end col-lg-6 mb-2">
                        <form className="sForm">
                            <input type="text" className="form-control form-control-lg w-100" id="s" placeholder="Search" />
                        </form>
                    </div>
                </div>
                <div className="table-responsive">
                    <table className="table table-borderless table-hover">
                        <thead>
                            <tr>
                                <th scope="col" width="45" align="center">
                                    <div className="selectAll">
                                        <input className="form-check-input" type="checkbox" />
                                    </div>
                                </th>
                                <th scope="col" width="80">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">SR.</span>
                                        <button className="filtBtn idFilter"><Icon className="arrowUp" icon={arrowUp} size={18}/></button>
                                    </div>                                    
                                </th>
                                <th scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Seller Code</span>
                                        <button className="filtBtn sCodeFilter"><Icon className="arrowUp" icon={arrowUp} size={18}/></button>
                                    </div>
                                </th>
                                <th scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">First Name</span>
                                        <button className="filtBtn fNameFilter"><Icon className="arrowUp" icon={arrowUp} size={18}/></button>
                                    </div>
                                </th>
                                <th scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Last Name</span>
                                        <button className="filtBtn lNameFilter"><Icon className="arrowUp" icon={arrowUp} size={18}/></button>
                                    </div>
                                </th>
                                <th scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Status</span>
                                        <button className="filtBtn statusFilter"><Icon className="arrowUp" icon={arrowUp} size={18}/></button>
                                    </div>
                                </th>
                                <th scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Email</span>
                                        <button className="filtBtn emailFilter"><Icon className="arrowUp" icon={arrowUp} size={18}/></button>
                                    </div>
                                </th>
                                <th scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Action</span>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody className="table-group-divider">
                            <tr>
                                <td><input className="form-check-input" type="checkbox" /></td>
                                <th scope="row">1</th>
                                <td>Seller1</td>
                                <td>Vahid</td>
                                <td>Ali</td>
                                <td>
                                    <span className="badge text-bg-warning">In Process</span>
                                </td>
                                <td>vahidtest@mail.com</td>
                                <td>
                                    <div className="d-grid gap-2 d-md-block">
                                        <button type="button" className="actBtn delBtn">
                                            <Icon className="trash" icon={trash} size={18}/>
                                            <span className="toolTip">Delete</span>
                                        </button> &nbsp;
                                        <button type="button" className="actBtn editBtn">
                                            <Icon className="arrowUpRight" icon={arrowUpRight} size={18}/>
                                            <span className="toolTip">Edit</span>
                                        </button> &nbsp;
                                        <button type="button" className="actBtn viewBtn">
                                            <Icon className="eye" icon={eye} size={18}/>
                                            <span className="toolTip">Preview</span>
                                        </button>
                                    </div> 
                                </td>
                            </tr>
                            <tr>
                                <td><input className="form-check-input" type="checkbox" /></td>
                                <th scope="row">1</th>
                                <td>Seller1</td>
                                <td>Vahid</td>
                                <td>Ali</td>
                                <td>
                                    <span className="badge text-bg-success">Active</span>
                                </td>
                                <td>vahidtest@mail.com</td>
                                <td>
                                    <div className="d-grid gap-2 d-md-block">
                                        <button type="button" className="actBtn delBtn">
                                            <Icon className="trash" icon={trash} size={18}/>
                                            <span className="toolTip">Delete</span>
                                        </button> &nbsp;
                                        <button type="button" className="actBtn editBtn">
                                            <Icon className="arrowUpRight" icon={arrowUpRight} size={18}/>
                                            <span className="toolTip">Edit</span>
                                        </button> &nbsp;
                                        <button type="button" className="actBtn viewBtn">
                                            <Icon className="eye" icon={eye} size={18}/>
                                            <span className="toolTip">Preview</span>
                                        </button>
                                    </div> 
                                </td>
                            </tr>
                            <tr>
                                <td><input className="form-check-input" type="checkbox" /></td>
                                <th scope="row">1</th>
                                <td>Seller1</td>
                                <td>Vahid</td>
                                <td>Ali</td>
                                <td>
                                    <span className="badge text-bg-danger">In Active</span>
                                </td>
                                <td>vahidtest@mail.com</td>
                                <td>
                                    <div className="d-grid gap-2 d-md-block">
                                        <button type="button" className="actBtn delBtn">
                                            <Icon className="trash" icon={trash} size={18}/>
                                            <span className="toolTip">Delete</span>
                                        </button> &nbsp;
                                        <button type="button" className="actBtn editBtn">
                                            <Icon className="arrowUpRight" icon={arrowUpRight} size={18}/>
                                            <span className="toolTip">Edit</span>
                                        </button> &nbsp;
                                        <button type="button" className="actBtn viewBtn">
                                            <Icon className="eye" icon={eye} size={18}/>
                                            <span className="toolTip">Preview</span>
                                        </button>
                                    </div> 
                                </td>
                            </tr>     
                        </tbody>
                    </table>
                </div>
                <div className="resultList pt-3 border-top">
                    <div className="row">
                        <div className="displayRecord col-lg-6 mb-2">
                            <span className="h6 mb-0">Showing 1 of 5 of 3 entries</span>
                        </div>
                        <div className="searchForm d-flex justify-content-end col-lg-6 mb-2">
                            <nav aria-label="...">
                                <ul className="pagination pagination-sm">
                                    <li className="page-item active" aria-current="page">
                                        <span className="page-link">1</span>
                                    </li>
                                    <li className="page-item"><NavLink to="#" className="page-link">2</NavLink></li>
                                    <li className="page-item"><NavLink to="#" className="page-link">3</NavLink></li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
  }
export default List;
